import "./Comparison_Two.css";
import { useEffect, useState } from "react";
export default function Comparison_Two({ Prediction, teamcode, setdisplay }) {
  console.log("teamcody", teamcode);
  const [GoalData, setGoalData] = useState(null);
  const [CornerData, setCornerData] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const API_URL = process.env.REACT_APP_API_FAST || "http://192.168.1.103:8000";
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedOption) {
      alert("Please select a prediction");
      return;
    }

    try {
      const response = await fetch(
        `${API_URL}/virtual/select_team`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            teamcode: teamcode,
            prediction: selectedOption,
          }),
        },
      );
      console.log("HTTP status:", response.status);
      console.log("HTTP OK:", response.ok);
      const data = await response.json();
      console.log("Added to virtual table:", data);
      if (response.status === 404) {
        alert(data.detail);
        return;
      }

      if (!response.ok) {
        alert(data.detail || "Something went wrong");
        return;
      }
      setdisplay(false);
    } catch (error) {
      console.error("Error submitting prediction:", error);
    }
  };

  // ------ MERGED GOAL ANALYTICS ------
  useEffect(() => {
    if (!teamcode) return;

    const fetchTeam = async () => {
      try {
        const response = await fetch(
          `${API_URL}/goal_merged_analytic/${teamcode}`,
        );
        const data = await response.json();
        console.log("dataaa", data);
        setGoalData(data);
      } catch (err) {
        console.error("Error fetching team:", err);
      }
    };
    fetchTeam();
  }, [teamcode]);

  // -------- MERGED CORER ANALYTICS ---------
  useEffect(() => {
    if (!teamcode) return;

    const fetchTeam = async () => {
      try {
        const response = await fetch(
          `${API_URL}/corner_merged_analytic/${teamcode}`,
        );
        const data = await response.json();
        console.log("CORNER MERGED", data);
        setCornerData(data);
      } catch (err) {
        console.error("Error fetching team:", err);
      }
    };
    fetchTeam();
  }, [teamcode]);

  // ----- GOAL SECTION
  const GoalsSection = () => {
    return (
      <section className="comparison_panel">
        <div className="comparison_header">
          <div>
            <span className="comparison_kicker">MATCH ANALYSIS</span>
            <h3>Goals</h3>
          </div>

          <div className="prediction_badge">
            <span>Predicted</span>
            <strong>
              {GoalData
                ? (
                  Number(GoalData.mean_goals_home || 0) +
                  Number(GoalData.mean_goals_away || 0)
                ).toFixed(2)
                : "--"}
            </strong>
          </div>
        </div>

        <div className="comparison_table">
          {/* TABLE HEADER */}
          <div className="comparison_row comparison_table_header">
            <div>Metric</div>
            <div>Home</div>
            <div>Away</div>
          </div>

          {/* GOALS */}
          <div className="comparison_row">
            <div className="metric_name">
              <span className="metric_dot"></span>
              Goals
            </div>

            <div className="metric_value">
              {GoalData?.goal_values_home ?? "--"}
            </div>

            <div className="metric_value">
              {GoalData?.goal_values_away ?? "--"}
            </div>
          </div>

          {/* MEAN */}
          <div className="comparison_row">
            <div className="metric_name">
              <span className="metric_dot"></span>
              Mean
            </div>

            <div className="metric_value">
              {GoalData?.mean_goals_home ?? "--"}
            </div>

            <div className="metric_value">
              {GoalData?.mean_goals_away ?? "--"}
            </div>
          </div>

          {/* H2H */}
          <div className="comparison_row">
            <div className="metric_name">
              <span className="metric_dot"></span>
              H-2-H
            </div>

            <div className="metric_value">{GoalData?.Home_score ?? "--"}</div>

            <div className="metric_value">{GoalData?.Away_score ?? "--"}</div>
          </div>

          {/* CV */}
          <div className="comparison_row">
            <div className="metric_name">
              <span className="metric_dot"></span>
              CV
            </div>

            <div className="metric_value">{GoalData?.cv_home ?? "--"}</div>

            <div className="metric_value">{GoalData?.cv_away ?? "--"}</div>
          </div>
        </div>
      </section>
    );
  };

  // ------- CORNER SECTION
  const CornerSection = () => {
    return (
      <section className="comparison_panel">
        <div className="comparison_header">
          <div>
            <span className="comparison_kicker">MATCH ANALYSIS</span>
            <h3>Corners</h3>
          </div>

          <div className="prediction_badge">
            <span>Predicted</span>
            <strong>
              {CornerData
                ? (
                  Number(CornerData.mean_corners_home || 0) +
                  Number(CornerData.mean_corners_away || 0)
                ).toFixed(2)
                : "--"}
            </strong>
          </div>
        </div>

        <div className="comparison_table">
          <div className="comparison_row comparison_table_header">
            <div>Metric</div>
            <div>Home</div>
            <div>Away</div>
          </div>

          <div className="comparison_row">
            <div className="metric_name">
              <span className="metric_dot"></span>
              Corners
            </div>

            <div className="metric_value">
              {CornerData?.corner_values_home ?? "--"}
            </div>

            <div className="metric_value">
              {CornerData?.corner_values_away ?? "--"}
            </div>
          </div>

          <div className="comparison_row">
            <div className="metric_name">
              <span className="metric_dot"></span>
              Mean
            </div>

            <div className="metric_value">
              {CornerData?.mean_corners_home ?? "--"}
            </div>

            <div className="metric_value">
              {CornerData?.mean_corners_away ?? "--"}
            </div>
          </div>

          <div className="comparison_row">
            <div className="metric_name">
              <span className="metric_dot"></span>
              H-2-H
            </div>

            <div className="metric_value">
              {CornerData?.Home_corners ?? "--"}
            </div>

            <div className="metric_value">
              {CornerData?.Away_corners ?? "--"}
            </div>
          </div>

          <div className="comparison_row">
            <div className="metric_name">
              <span className="metric_dot"></span>
              CV
            </div>

            <div className="metric_value">{CornerData?.cv_home ?? "--"}</div>

            <div className="metric_value">{CornerData?.cv_away ?? "--"}</div>
          </div>
        </div>
      </section>
    );
  };
  return (
    <>
      <div className="combined_section">
        <GoalsSection />
        <CornerSection />
      </div>
    </>
  );
}
